




























import useZipFileArchiver from "@/composables/v3/useZipFileArchiver";
import toastificationContent from "@/layouts/components/toastification/toastificationContent.vue";
import i18n from "@/libs/i18n";
import { useDownloadAttachmentsStore } from "@/store/useDownloadAttachmentsStore";
import { defineComponent, Ref } from "@vue/composition-api";
import { BDropdown, BDropdownItem, BSpinner, VBTooltip } from "bootstrap-vue";
import { storeToRefs } from "pinia";
import { useToast } from "vue-toastification/composition";

export default defineComponent({
    components: {
        BSpinner,
        BDropdown,
        BDropdownItem,
    },
    directives: {
        "b-tooltip": VBTooltip,
    },
    setup(_, { root }) {
        const toast = useToast();
        const { clearDownloads, downloadsLimit } = useDownloadAttachmentsStore();
        const { downloadsCount }: { downloadsCount: Ref<number> } = storeToRefs(useDownloadAttachmentsStore());
        const { isGeneratingArchive } = useZipFileArchiver();

        const generateArchive = () => {
            const { generateArchive } = useZipFileArchiver();

            generateArchive()
                .catch(() => {
                    toast({
                        component: toastificationContent,
                        props: {
                            title: i18n.tc("download-files-count", downloadsCount.value),
                            text: i18n.t("generating-zip-error"),
                            icon: "times",
                            variant: "error",
                        },
                    });
                })
                .finally(() => root.$emit("bv::hide::tooltip"));
        };

        return {
            downloadsLimit,
            downloadsCount,
            clearDownloads,
            generateArchive,
            isGeneratingArchive,
        };
    },
});
